import { getFetcherWithToken } from "src/utils/Fetcher";
import { getMediaUri } from "src/utils/media";

function getEventHistories() {
  return (token) =>
    getFetcherWithToken(token)
      .get(`/event/history`)
      .then((res) => {
        const { event_histories, event } = res.data;
        return {
          histories: event_histories,
          event: {
            ...event,
            image_uri: event.image_uri ? getMediaUri(event.image_uri) : null,
          },
        };
      });
}

function getEventUserHistories() {
  return (token) =>
    getFetcherWithToken(token)
      .get(`/event/user/history`)
      .then((res) => {
        const { event_histories } = res.data;
        return {
          eventHistories: event_histories,
        };
      });
}

export default {
  getEventHistories,
  getEventUserHistories,
};
